import NoSearchResultsRobot from 'assets/robots/no_search_results_robot.svg';
import NoSearchResultsRobotWhite from 'assets/robots/no_search_results_robot_white.svg';
import ServerErrorRobot from 'assets/robots/robot-server-error.svg';
import classnames from 'classnames';
import styles from './NoSearchResults.module.css';
export enum NoResultsMessage {
  TRY_DIFFERENT_WORDS = 'try_different_words',
  TRY_DIFFERENT_FILTERS = 'try_different_filters',
}
interface NoSearchResultsProps {
  darkTheme?: boolean;
  hasError?: boolean;
  noResultsMessage?: NoResultsMessage;
}
const NoSearchResults = ({
  darkTheme = false,
  hasError,
  noResultsMessage = NoResultsMessage.TRY_DIFFERENT_WORDS
}: NoSearchResultsProps) => <div className={classnames(styles.noResults, {
  [`${styles.noResultsDarkTheme}`]: darkTheme
})} data-sentry-component="NoSearchResults" data-sentry-source-file="NoSearchResults.tsx">
    {hasError ? <>
        <h2 className={styles.header} data-testid="no-search-results-header" data-trk="no-search-results">
          Något gick fel
        </h2>
        <p className={styles.text}>Vi upplever tekniska problem just nu.</p>
        <p className={styles.text}>Vänligen försök igen senare.</p>
        {darkTheme ? <ServerErrorRobot aria-hidden className={styles.robot} focusable="false" /> : <ServerErrorRobot aria-hidden className={classnames(styles.robot, styles.robotBackground)} focusable="false" />}
      </> : <>
        <h2 className={styles.header} data-testid="no-search-results-header" data-trk="no-search-results">
          Vi hittade inga program
        </h2>

        {noResultsMessage === NoResultsMessage.TRY_DIFFERENT_FILTERS ? <p className={styles.text}>Testa att välja färre filter</p> : <>
            <p className={styles.text}>
              Kontrollera att alla ord är rättstavade.
            </p>
            <p className={styles.text}>Försök med andra sökord.</p>
            <p className={styles.text}>Försök med färre sökord.</p>
          </>}

        {darkTheme ? <NoSearchResultsRobotWhite aria-hidden className={styles.robot} focusable="false" /> : <NoSearchResultsRobot aria-hidden className={styles.robot} focusable="false" />}
      </>}
  </div>;
export default NoSearchResults;